import React from 'react'
import './icon.css';

interface Props {
    children : string;
}

export class Icon extends React.Component<Props> {

    render() {
        return (
            <div className="icon">
                <span>
                { this.props.children }
                </span>
            </div>
        );
    }
}

